import { LabelType, PossibleLabelValue } from "../../context/ConfigContext/types";
import { LabelOutputType } from "../../context/ConfigContext/types";

export enum ConfigOrLabel {
  SCRAPER_CONFIGS = "Scraper Configs",
  LABELS = "Labels",
}

export interface AdminPanelLabel {
  id: number;
  name: string;
  type: LabelType;
  outputType: LabelOutputType;
  possibleLabelValues: PossibleLabelValue[];
  active: boolean;
  topicId?: number;
}

export interface AdminPanelTopic {
  id: number;
  name: string;
  labels: AdminPanelLabel[];
  scraperConfigs: ScraperConfig[];
}

export interface AdminPanelClient {
  id: number;
  name: string;
}

export interface ScraperConfig {
  id: number;
  active: boolean;
  scraperConfigOptions: ScraperConfigOption[];
  name?: string;
  creationDatetime?: string;
  topicId?: number;
  scraper?: Scraper;
}

export interface ScraperConfigOption {
  id: number;
  name: string;
  creationDatetime?: string;
  scraperConfigOptionValues: ScraperConfigOptionValue[];
}

export interface ScraperConfigOptionValue {
  id: number;
  value: string;
  active: boolean;
  creationDatetime?: string;
}

export interface Scraper {
  id: number;
  name: string;
  type: string;
}
